import Icon from '@atoms/Icon/Icon';
import { IContentOverlay } from '@models/IContentOverlay';
import IconSizeEnum from '@models/enums/IconSizeEnum';
import InfoTypeEnum from '@models/enums/InfoTypeEnum';
import InfoModal from '@molecules/InfoModal/InfoModal';
import classNames from 'classnames';
import { useState } from 'react';

const ContentOverlay = ({
  caption,
  captionForIcon,
  className = 'h4',
  infoIconSize = IconSizeEnum.md,
  isSubscript = false,
  showInfoIcon = true,
  text,
  title,
  dataTestId = 'CT-87-Content-Overlay',
}: IContentOverlay) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!caption && !text) {
    return null;
  }

  return (
    <button
      className={classNames(
        'items-start gap-x-1',
        isSubscript ? 'inline-flex align-super' : 'flex'
      )}
      onClick={() => setIsOpen(!isOpen)}
      type="button"
      aria-label={captionForIcon ?? caption}
    >
      {captionForIcon && <div className={className}>{captionForIcon}</div>}

      {showInfoIcon && (
        <Icon
          colorClassName="text-black-100 dark:text-white"
          name="info"
          size={infoIconSize}
        />
      )}
      <InfoModal
        description={text}
        isModalOpen={isOpen}
        secondaryTitle={title}
        title={caption}
        toggleModal={setIsOpen}
        type={InfoTypeEnum.ContentOverlay}
        dataTestId={dataTestId}
      />
    </button>
  );
};

export default ContentOverlay;
